/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Náš tým pro prostředí na pracovišti nyní začne kouzlit a zpracuje vaši žádost o obdarování. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Gratulace byla vytvořena',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Vytvoření gratulace nebo odeslání dárku se nezdařilo. Zkuste zadat samostatný ticket na stránce <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Něco se pokazilo',
  'team-central.give-kudos.button': 'Pogratulovat',
  'team-central.give-kudos.close-button.label': 'Zavřít panel',
  'team-central.give-kudos.confirm-close.title': 'Potvrdit zavření',
  'team-central.give-kudos.created.description.flag': 'Vaše gratulace byla odeslána. <a>Zobrazit gratulaci</a>',
  'team-central.give-kudos.created.title.flag': 'Gratulace byla vytvořena',
  'team-central.give-kudos.creation.failed.description.flag': 'Vytvoření gratulace se nezdařilo.',
  'team-central.give-kudos.creation.failed.title.flag': 'Něco se pokazilo',
  'team-central.give-kudos.error-icon.label': 'Chyba',
  'team-central.give-kudos.success-icon.label': 'Úspěch',
  'team-central.give-kudos.unsaved.warning': 'Změny, které jste provedli, se neuloží.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Zrušit',
  'team-central.give-kudos.unsaved.warning.close': 'Zavřít'
};